import { SnackbarProgrammatic as Snackbar } from 'buefy'
import { MAX_MEDIA_PER_GALLERY, MAX_SUBMISSIONS_PER_POST } from './constants'

// Auth
const EMAIL_DOES_NOT_EXIST = 'emailDoesNotExist'
const PASSWORD_INCORRECT = 'passwordIncorrect'
const PASSWORDS_NOT_MATCH = 'passwordsNotMatch'
const WRONG_TOKEN = 'wrongToken'
const DUPLICATE_EMAIL = 'duplicateEmail'
const PASSWORD_TOO_SHORT = 'password_too_short'
const PASSWORD_TOO_COMMON = 'password_too_common'
const PASSWORD_TOO_SIMILAR = 'password_too_similar'
const PASSWORD_ENTIRELY_NUMERIC = 'password_entirely_numeric'

// Reddit posts
const SUBREDDIT_DOES_NOT_EXIST = 'subredditDoesNotExist'
const LINK_POST_NOT_ALLOWED = 'linkPostNotAllowed'
const SELF_POST_NOT_ALLOWED = 'selfPostNotAllowed'
const POLL_POST_NOT_ALLOWED = 'pollPostNotAllowed'
const IMAGE_POST_NOT_ALLOWED = 'imagePostNotAllowed'
const GIF_POST_NOT_ALLOWED = 'gifPostNotAllowed'
const VIDEO_POST_NOT_ALLOWED = 'videoPostNotAllowed'
const GALLERY_POST_NOT_ALLOWED = 'galleryPostNotAllowed'
const NOT_LOGGED_IN = 'notLoggedIn'
const ACCESS_DENIED = 'accessDenied'
const LINK_OR_CONTENT_ONLY_ONE = 'linkOrContentOnlyOne'
const COMMENT_MAX_LENGTH = 'commentMaxLength'
const REDDIT_ACCOUNT_NOT_LINKED = 'redditAccountNotLinked'
const POST_OUTSIDE_OF_PLAN = 'postOutsideOfPlan'
const INVALID_URL = 'invalidURL'
const EDIT_SCOPE_NOT_ENABLED = 'editScopeNotEnabled'
const TITLE_TOO_LONG = 'titleTooLong'
const TOO_MANY_SUBMISSIONS = 'tooManySubmissions'
const TOO_MANY_MEDIA_PER_GALLERY = 'tooManyMediaPerGallery'
const DRAFT_WITH_SUBMITTED_SUBMISSIONS = 'draftWithSubmittedSubmissions'
const SUBMISSION_DATE_IN_PAST = 'submissionDateInPast'
const BULK_IMPORT_INVALID_DATE_TIME_FORMAT = 'bulkImportInvalidDateTimeFormat'
const MISSING_SUBMISSION_ID = 'missingSubmissionId'

// Campaigns
const DUPLICATE_CAMPAIGN_NAME = 'duplicateCampaignName'

// Content Library
const ACCOUNT_STORAGE_EXCEEDED = 'accountStorageExceeded'
const MEDIA_NOT_FOUND = 'mediaNotFound'

// DMs
const TEMPLATE_EXISTS_FOR_AUTHOR = 'templateExistsForAuthor'
const DMS_NOT_ENABLED_FOR_AUTHOR = 'dmsNotEnabledForAuthor'
const SUBJECT_MALFORMATTED = 'subjectMalformatted'
const BODY_MALFORMATTED = 'bodyMalformatted'
const SUBJECT_INVALID_VARIABLE = 'subjectInvalidVariable'
const BODY_INVALID_VARIABLE = 'bodyInvalidVariable'

const DM_INVALID_USER = 'INVALID_USER'
const DM_USER_DOESNT_EXIST = 'USER_DOESNT_EXIST'
const DM_NOT_WHITELISTED_BY_USER_MESSAGE = 'NOT_WHITELISTED_BY_USER_MESSAGE'
const DM_RESTRICTED_TO_PM = 'RESTRICTED_TO_PM'
const DM_PM_MODERATOR_RESTRICTION = 'PM_MODERATOR_RESTRICTION'
const DM_RATELIMIT = 'RATELIMIT'
const DM_BANNED_FROM_SUBREDDIT = 'BANNED_FROM_SUBREDDIT'

// Users
const INVALID_PREFERENCE = 'invalidPreference'

// Stripe errors
const STRIPE_CARD_DECLINED = 'STRIPE_CARD_DECLINED'
const STRIPE_EXPIRED_CARD = 'STRIPE_EXPIRED_CARD'
const STRIPE_COUNTRY_UNSUPPORTED = 'STRIPE_COUNTRY_UNSUPPORTED'
const STRIPE_INCORRECT_ADDRESS = 'STRIPE_INCORRECT_ADDRESS'
const STRIPE_INCORRECT_CVC = 'STRIPE_INCORRECT_CVC'
const STRIPE_INCORRECT_NUMBER = 'STRIPE_INCORRECT_NUMBER'
const STRIPE_INCORRECT_ZIP = 'STRIPE_INCORRECT_ZIP'
const STRIPE_INSUFFICIENT_FUNDS = 'STRIPE_INSUFFICIENT_FUNDS'
const STRIPE_PROCESSING_ERROR = 'STRIPE_PROCESSING_ERROR'

const errorMessages = new Map([
  // Auth
  [
    EMAIL_DOES_NOT_EXIST,
    "We couldn't find a user with that email. Please try again."
  ],
  [PASSWORD_INCORRECT, 'Current password is incorrect'],
  [PASSWORDS_NOT_MATCH, 'Passwords do not match'],
  [WRONG_TOKEN, 'Password reset link has expired'],
  [
    DUPLICATE_EMAIL,
    'That email is already associated with a different Postpone user. Please log in with that email or use a different one. Reach out via chat if you need any assistance.'
  ],
  [PASSWORD_TOO_SHORT, 'Your password must contain at least 8 characters.'],
  [PASSWORD_TOO_COMMON, "Your password can't be a commonly used password."],
  [
    PASSWORD_TOO_SIMILAR,
    "Your password can't be too similar to your other personal information."
  ],
  [PASSWORD_ENTIRELY_NUMERIC, "Your password can't be entirely numeric."],

  // Reddit posts
  [SUBREDDIT_DOES_NOT_EXIST, 'The subreddit does not exist'],
  [
    LINK_POST_NOT_ALLOWED,
    'Link posts are not allowed by one or more subreddits'
  ],
  [
    SELF_POST_NOT_ALLOWED,
    'Self posts are not allowed by one or more subreddits'
  ],
  [
    POLL_POST_NOT_ALLOWED,
    'Poll posts are not allowed by one or more subreddits'
  ],
  [
    IMAGE_POST_NOT_ALLOWED,
    'Image posts are not allowed by one or more subreddits'
  ],
  [GIF_POST_NOT_ALLOWED, 'GIF posts are not allowed by one or more subreddits'],
  [
    VIDEO_POST_NOT_ALLOWED,
    'Video posts are not allowed by one or more subreddits'
  ],
  [
    GALLERY_POST_NOT_ALLOWED,
    'Gallery posts are not allowed by one or more subreddits'
  ],
  [NOT_LOGGED_IN, 'You are not logged in. Login to continue'],
  [ACCESS_DENIED, 'You are not allowed to perform that action'],
  [LINK_OR_CONTENT_ONLY_ONE, 'Must submit link or content, but not both'],
  [COMMENT_MAX_LENGTH, 'Comment cannot be more than 10,000 characters'],
  [
    REDDIT_ACCOUNT_NOT_LINKED,
    'That Reddit account has not been linked to Postpone'
  ],
  [INVALID_URL, "That isn't a valid URL"],
  [
    POST_OUTSIDE_OF_PLAN,
    'Post outside of plan limits for the scheduled month. Upgrade to schedule additional Reddit posts.'
  ],
  [
    EDIT_SCOPE_NOT_ENABLED,
    'Postpone needs elevated permissions to auto-remove posts from this Reddit account. Please log into Postpone again with this Reddit account to proceed.'
  ],
  [TITLE_TOO_LONG, "Post titles can't be longer than 300 characters."],
  [
    TOO_MANY_SUBMISSIONS,
    `You can only schedule up to ${MAX_SUBMISSIONS_PER_POST} submissions per post.`
  ],
  [
    TOO_MANY_MEDIA_PER_GALLERY,
    `You can only add up to ${MAX_MEDIA_PER_GALLERY} media items per gallery.`
  ],
  [
    DRAFT_WITH_SUBMITTED_SUBMISSIONS,
    'You cannot turn a submitted post into a draft.'
  ],
  [
    SUBMISSION_DATE_IN_PAST,
    'Submission date must be in the future. Please select a future date.'
  ],
  [
    BULK_IMPORT_INVALID_DATE_TIME_FORMAT,
    'Invalid date/time format in the post_at column for one or more rows. Please use the format YYYY-MM-DD HH:MM'
  ],
  [
    MISSING_SUBMISSION_ID,
    'Post is not linked to platform. Please fix it in History and try again.'
  ],
  [
    // Campaigns
    (DUPLICATE_CAMPAIGN_NAME,
    'Duplicate post template name. Please create a unique post template name.')
  ],
  // Content Library
  [
    ACCOUNT_STORAGE_EXCEEDED,
    'Account storage limit exceeded. Upgrade to store more images and videos in the Content Library.'
  ],
  [
    MEDIA_NOT_FOUND,
    'Image or video not found. Please refresh the page and try again.'
  ],
  // DMs
  [
    TEMPLATE_EXISTS_FOR_AUTHOR,
    'A message template already exists for at least one of the chosen Reddit accounts.'
  ],
  [
    DMS_NOT_ENABLED_FOR_AUTHOR,
    'Postpone cannot send DMs from at least one of the chosen Reddit accounts. Log into Postpone with that Reddit account then try again.'
  ],
  [
    SUBJECT_MALFORMATTED,
    'Subject is malformatted. Make sure your opening bracket { has a closing bracket }'
  ],
  [
    BODY_MALFORMATTED,
    'Body is malformatted. Make sure your opening bracket { has a closing bracket }'
  ],
  [
    SUBJECT_INVALID_VARIABLE,
    'Subject has an invalid variable. Make sure the subject only uses one of the provided variables with no spaces, e.g. {redditor}'
  ],
  [
    BODY_INVALID_VARIABLE,
    'Body has an invalid variable. Make sure the body only uses one of the provided variables with no spaces, e.g. {redditor}'
  ],
  [DM_INVALID_USER, 'The Redditor may be suspended or deleted.'],
  [DM_USER_DOESNT_EXIST, "The user's Reddit account no longer exists."],
  [
    DM_NOT_WHITELISTED_BY_USER_MESSAGE,
    'This Redditor does not allow you to send them messages.'
  ],
  [
    DM_BANNED_FROM_SUBREDDIT,
    'Your Reddit account is banned from this subreddit.'
  ],
  [
    DM_RATELIMIT,
    'Reddit is rate limiting your account. Please try again in 5-15 minutes.'
  ],
  [DM_RESTRICTED_TO_PM, "This user doesn't accept direct messages."],
  [
    DM_PM_MODERATOR_RESTRICTION,
    "You can't message this person. If you need to speak to a moderator, send a message directly to the community (e.g. r/...)."
  ],
  // Users
  [INVALID_PREFERENCE, 'Invalid preference name.'],
  // Stripe
  [STRIPE_CARD_DECLINED, 'Your credit card was declined'],
  [
    STRIPE_EXPIRED_CARD,
    'The card has expired. Check the expiration date or use a different card.'
  ],
  [STRIPE_COUNTRY_UNSUPPORTED, 'Unsupported country'],
  [
    STRIPE_INCORRECT_ADDRESS,
    "The card’s address is incorrect. Check the card's address or use a different card."
  ],
  [
    STRIPE_INCORRECT_CVC,
    "The card’s security code is incorrect. Check the card's security code or use a different card."
  ],
  [
    STRIPE_INCORRECT_NUMBER,
    "The card number is incorrect. Check the card's number or use a different card."
  ],
  [
    STRIPE_INCORRECT_ZIP,
    "The card’s ZIP code is incorrect. Check the card's ZIP code or use a different card."
  ],
  [
    STRIPE_INSUFFICIENT_FUNDS,
    'The card has insufficient funds. Add funds to this card or use a different card.'
  ],
  [
    STRIPE_PROCESSING_ERROR,
    'An error occurred while processing the card. Try again later or with a different payment method.'
  ]
])

export function handleBackendErrors(errors, prefix = '') {
  for (let error of errors) {
    let message = errorMessages.get(error)
    if (!message) {
      console.warn(
        `Error code "${error}" has no defined message. Using default.`
      )
      message = 'An error has occurred. Please try again.'
    }

    if (prefix) {
      message = `${prefix}: ${message}`
    }

    Snackbar.open({
      message: message,
      type: 'is-warning',
      duration: 5000,
      position: 'is-top',
      queue: false
    })
  }
}

export function handleBackendValidationErrors(validationErrors) {
  for (let error of validationErrors) {
    Snackbar.open({
      message: error.message,
      type: 'is-warning',
      duration: 5000,
      position: 'is-top',
      queue: false
    })
  }
}
